
import React, { useState, useContext, useEffect } from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, ListItemIcon } from "@material-ui/core"
import MenuIcon from '@material-ui/icons/Menu';
import PhoneIcon from '@material-ui/icons/Phone';
import { useHistory, useLocation } from "react-router-dom";
import './SideMenu.scss'
import { isMobile } from "react-device-detect";
import { SessionService } from "../../services/SessionService";
import { ReactComponent as MonthlySvg } from '../../assets/sidemenu/monthly.svg'
import { ReactComponent as ClaimsSvg } from '../../assets/sidemenu/claims.svg'
import { ReactComponent as AnnualSvg } from '../../assets/sidemenu/annual.svg'
import { ReactComponent as BugSvg } from '../../assets/sidemenu/bug.svg'
import { ReactComponent as FaqSvg } from '../../assets/sidemenu/faq.svg'
import { ReactComponent as LoginSvg } from '../../assets/sidemenu/login.svg'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { ReactComponent as PolicyManagementSvg } from '../../assets/sidemenu/policy_management.svg'
import EqualizerIcon from '@material-ui/icons/Equalizer';
import HomeIcon from '@material-ui/icons/Home';
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService";
import FlexView from "react-flexview/lib";
import { SideMenuUserCircle } from "./SideMenuUserCircle";
import { AppBarProfile } from "./AppBarItems/AppBarProfile";
import BrokerConfigService from "../../services/BrokerConfigService";
import { SessionContextStore } from "../../context/SessionContext";
import { InsuranceTypes } from "../../models/insurance-models/InsuranceBillingPeriodModel";
import { SkywatchThemeContext } from "../../theme/Theme";
import { SupportPhoneCall } from "./AppBarItems/SupportPhoneCall";
import { SkyCookiesConsent } from '../../components/Core/SkyCookiesConsent';
import { LogoutPopup } from "../Logout/LogoutPopup";
var classNames = require('classnames');

const MONTHLY_ROUTE = {text: "Monthly Insurance", path: "/insurance/monthly", showIfLoggedOut: FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE), showIfLoggedIn: FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE), icon: <MonthlySvg className="medium-icon" />, active: p => p.endsWith('monthly') };
const ANNUAL_ROUTE = {text: "Annual Insurance", path: "/insurance/annual", showIfLoggedOut: FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE), showIfLoggedIn: FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE), icon: <AnnualSvg className="medium-icon"/>, active: p => p.endsWith('annual')};
const ROUTES = [
    {text: "Policy Management", path: "/policy-management", showIfLoggedOut: false, showIfLoggedIn: true, icon: <PolicyManagementSvg className="medium-icon"/>, active: p => p.startsWith('/policy-management')},
    {text: "Account", path: "/account", showIfLoggedOut: false, showIfLoggedIn: true, icon: <LoginSvg className="medium-icon"/>, active: p => p.startsWith('/account')},
    FirebaseService.getBoolean(FirebaseConfigKey.INSURED_LOGIN_AVAILABLE) && {text: "Login", path: "/login", showIfLoggedOut: true, showIfLoggedIn: false, icon: <LoginSvg className="medium-icon"/>, active: p => p.endsWith('/login') || p.endsWith('logout')},
    {text: "Logout", path: "/logout", showIfLoggedOut: false, showIfLoggedIn: true, icon: <ExitToAppIcon className="medium-icon"/>, active: p => p.endsWith('logout')},
    {text: "File a Claim", path: '/claim', showIfLoggedOut: true, showIfLoggedIn: true, icon: <ClaimsSvg className="medium-icon"/>, active: p => false},
    FirebaseService.getValue(FirebaseConfigKey.FAQ_URL) && {text: "FAQ", link: true, path: FirebaseService.getValue(FirebaseConfigKey.FAQ_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <FaqSvg className="medium-icon"/>, active: p => false},
]

const BROKER_ROUTES = [
    {text: "Broker Portal", path: "/broker/portal", showIfLoggedOut: false, showIfLoggedIn: true, icon: <HomeIcon className="tealblue medium-icon"/>, active: p => p.endsWith('/portal')},
    {text: "Recent Submissions", path: "/broker/accounts/recent", params: {tab: "recent"}, showIfLoggedOut: false, showIfLoggedIn: true, icon: <MonthlySvg className="medium-icon"/>, active: p => p.endsWith('/accounts/recent')},
    {text: "Manage Accounts", path: "/broker/accounts/active", params: {tab: "active"}, showIfLoggedOut: false, showIfLoggedIn: true, icon: <LoginSvg className="medium-icon"/>, active: p => p.endsWith('/accounts/active')},
    {text: "Skywatch Dashboard", link: true, path: "http://partnerd.eastus.cloudapp.azure.com/pages/dashboard", showIfLoggedOut: false, showIfLoggedIn: true, icon: <EqualizerIcon className="tealblue medium-icon "/>, active: () => false},
    {text: "Logout", path: "/logout", showIfLoggedOut: false, showIfLoggedIn: true, icon: <ExitToAppIcon className="medium-icon"/>, active: p => p.endsWith('logout')},
    FirebaseService.getValue(FirebaseConfigKey.FAQ_URL) && {text: "FAQ", link: true, path: FirebaseService.getValue(FirebaseConfigKey.FAQ_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <FaqSvg className="medium-icon"/>, active: p => false},
]

const END_MENU_ROUTES = [
    // FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL) && {text: "Report a Bug", link: true, path: FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <BugSvg className="medium-icon"/>, active: p => false},
    {text: "Contact Us", link: true, path: FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_MENU_URL), showIfLoggedOut: true, showIfLoggedIn: true, icon: <PhoneIcon className="medium-icon"/>, active: p => false},
]

const useStyles = makeStyles({
    list: {
      width: 300,
    },
});


const SideMenu = (props) => {
    const [toggle, setToggle] = useState(false)
    const [activeInsuranceType, setActiveInsuranceType] = useState(undefined);
    const [isAnnualBroker, setIsAnnualBroker] = useState(false);
    const history = useHistory()
    const classes = useStyles()
    const location = useLocation();
    const sessionContext = useContext(SessionContextStore);
    const theme = useContext(SkywatchThemeContext);
    const [logoutIsOpen, setLogoutIsOpen] = useState(false)

    const turnToggle = () => {setToggle(true)}

    const gotoHome = () => {
        if(location.pathname.startsWith('/proposal')) return
        history.push("/");
    }
    
    const redirect = (item) => {
        if(item.link)
            window.open(item.path, '_blank')
        else 
            history.push(item.path, item.params ? item.params : {})
        setToggle(false)
    }

    useEffect(() => {
        const isAnnual = async () => {
            const flag = await BrokerConfigService.isAnnualBroker()
            setIsAnnualBroker(flag);
        }
        isAnnual();
    },[])

    useEffect(() => {
        if (sessionContext.activeInsurance && sessionContext.activeInsurance.insuranceId){
            setActiveInsuranceType(sessionContext.activeInsurance.insuranceType)
        }
        else{
            setActiveInsuranceType(undefined);
        }
    }, [sessionContext.activeInsurance])

    const isProposalForm = location.pathname.includes('/proposal');

    const shouldShowAppBar = location.pathname !== '/declination' && location.pathname !== '/uud' ;

      //we currently don't want to show the phone number as it burdens the support team
    const shouldShowPhone = false

    let routes = SessionService.isLoggedIn() && SessionService.isBroker() ? BROKER_ROUTES : ROUTES
    if (SessionService.isBroker()){
        
    }
    else if (activeInsuranceType == InsuranceTypes.MONTHLY){
        routes = [ANNUAL_ROUTE, ...routes]        
    }
    else if (activeInsuranceType == InsuranceTypes.YEARLY){
        routes = [MONTHLY_ROUTE, ...routes]        
    }
    else{
        routes = [MONTHLY_ROUTE, ANNUAL_ROUTE, ...routes]        
    }

    const handleItemMenuClick = (item) => {
        if(item.text === 'Logout') {
            setLogoutIsOpen(true)
            setToggle(false)
        }
        else redirect(item)
    }
    

    return ( shouldShowAppBar &&
        <React.Fragment>
            <AppBar color={BrokerConfigService.isSkywatchBroker() ? 'primary' : 'secondary'} position='sticky'
                    elevation={isMobile ? 0 : undefined} 
                    className={classNames( {"skywatch-appbar": Boolean(theme.useColoredBackground)})}>
                <Toolbar>
                    <FlexView className="space-between full-width">
                        <FlexView vAlignContent={'center'}>
                            {!location.pathname.startsWith('/proposal') && 
                            <IconButton className="menu-icon" onClick={turnToggle} edge="start" aria-label="menu">
                                <MenuIcon fontSize="large" className={classNames({"hamburger": true})} />
                            </IconButton> }
                             <img onClick={gotoHome} className="skywatch-logo" src={BrokerConfigService.getLogo()} />
                        </FlexView>
                        {!isProposalForm && <FlexView>
                            {BrokerConfigService.isSkywatchBroker() && shouldShowPhone &&  
                                <SupportPhoneCall className="margin-right-basic" /> }
                            {SessionService.isLoggedIn() && <AppBarProfile /> }
                        </FlexView>}
                    </FlexView>
                </Toolbar>
                
            </AppBar>
            <SkyCookiesConsent />
            <Drawer open={toggle} onClose={() => { setToggle(false) }}>
                <div>
                    {SessionService.isLoggedIn() && <SideMenuUserCircle />}
                    <br />
                    <List className={classes.list}>
                        {routes.filter(route => SessionService.isLoggedIn() ? route.showIfLoggedIn : route.showIfLoggedOut).filter(route => !(route.text === 'Monthly Insurance' && isAnnualBroker)).map((item, index) => 
                            <ListItem className="sidemenu-listitem" button onClick={() => handleItemMenuClick(item)} key={index}>
                                <ListItemIcon className={classNames({'sidemenu-icon-active': item.active(location.pathname)})}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primaryTypographyProps={{className: classNames('sidemenu-item', 'lightteal', {'sidemenu-active': item.active(location.pathname)})}} primary={item.text} />
                            </ListItem>
                        )}
                    </List>
                </div>
                <List className={classes.list}>
                        {END_MENU_ROUTES.filter(route => SessionService.isLoggedIn() ? route.showIfLoggedIn : route.showIfLoggedOut).map((item, index) => 
                            <ListItem className="sidemenu-listitem" button onClick={() => redirect(item)} key={index}>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primaryTypographyProps={{className: classNames('sidemenu-item', 'lightteal', {'sidemenu-active': item.active(location.pathname)})}} primary={item.text} />
                            </ListItem>
                        )}
                    </List>
            </Drawer>
            <LogoutPopup isOpen={logoutIsOpen} setOpen={setLogoutIsOpen}/>
        </React.Fragment>
    )
}

export default SideMenu